import { useEffect } from 'react';

const siteName = 'The Skilled Group';
const defaultImage = '/logo/theskilledgroup-logo.png';

const upsertMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('meta');
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }

    element.setAttribute(key, value);
  });

  return element;
};

const upsertLink = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('link');
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }

    element.setAttribute(key, value);
  });

  return element;
};

const Seo = ({ title, description, canonicalPath, noIndex = false, image = defaultImage }) => {
  useEffect(() => {
    const pageTitle = title ? `${title} | ${siteName}` : siteName;
    document.title = pageTitle;

    upsertMeta('meta[name="description"]', { name: 'description', content: description || '' });
    upsertMeta('meta[name="robots"]', { name: 'robots', content: noIndex ? 'noindex,nofollow' : 'index,follow' });
    upsertMeta('meta[property="og:site_name"]', { property: 'og:site_name', content: siteName });
    upsertMeta('meta[property="og:title"]', { property: 'og:title', content: pageTitle });
    upsertMeta('meta[property="og:description"]', { property: 'og:description', content: description || '' });
    upsertMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' });
    upsertMeta('meta[property="og:image"]', { property: 'og:image', content: image });
    upsertMeta('meta[property="og:url"]', {
      property: 'og:url',
      content: canonicalPath ? `${window.location.origin}${canonicalPath}` : window.location.href,
    });
    upsertMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
    upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: pageTitle });
    upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: description || '' });
    upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: image });

    if (canonicalPath) {
      upsertLink('link[rel="canonical"]', {
        rel: 'canonical',
        href: `${window.location.origin}${canonicalPath}`,
      });
    }
  }, [canonicalPath, description, image, noIndex, title]);

  return null;
};

export default Seo;
